export default "__VITE_ASSET__HbGho91K__"